module.exports = __webpack_public_path__ + "media/flags/hr-1574acf8.svg";